export default __webpack_public_path__ + "static/hero1360-69fdedbb80363647e253f41c2e70b033.jpg";